import React, { useState } from "react";
import {
  Grid,
  GridNoRecords,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { EditCommandCell } from "../../pages/Settings/GridComponents";
import { GridLoader } from "components/GridLoader";
import { toast } from "react-toastify";

const List = ({
  editAction,
  editFormComponent: EditFormComponent,
  columns,
  component,
  gridData: externalGridData,
  loading: externalLoading,
  ...props
}) => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const data = externalGridData ?? [];
  const loading = externalLoading ?? false;

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    try {
      const id = event.activityTypeID ?? event?.timeTypeID;

      if (component !== "timeTypes" && component !== "activityTypes") {
        return;
      }
      const result = await editAction(id, event);
      if (result.success) {
        if (component === "timeTypes") {
          toast.success(`Time Type '${event?.name}' has been updated.`);
        } else {
          toast.success("Activity Type Updated successfully");
        }
        setOpenForm(false);
      }
    } catch (error) {}
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid-wrapper h-100">
      <div className="settings-grid h-100">
        <Grid
          data={data}
          showLoader={loading}
          style={{ height: "100%", width: "max-content", maxWidth: "100%" }}
          loader={
            <div style={{ minHeight: "50vh" }}>
              <GridLoader />
            </div>
          }>
          <GridNoRecords>
            {loading ? (
              <span></span>
            ) : (
              data && data?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          {columns.map((column, index) => (
            <Column key={index} {...column} />
          ))}
          <Column title=" " cell={MyEditCommandCell} width="60" />
        </Grid>
      </div>

      {openForm && (
        <EditFormComponent
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
        />
      )}
    </div>
  );
};

export default List;
